import { Component, Input, Output   } from '@angular/core'; 
import { NgxPaginationModule } from 'ngx-pagination';
import { AgencyService } from '../_Services/agency.service';
import { CommonService } from '../_Services/common.service';
import { Router, ActivatedRoute } from '@angular/router'; 



@Component({
  templateUrl: 'agency.component.html'
})
export class AgencyComponent {

    agencies = [];   

    p: any = 1; 

    paginator = []; 

	constructor(private agencyService: AgencyService) { }

	pageChanged(page: Number) {
		this.p = page;
	    this.agencyService.getRepoAgencies(page).subscribe(result => {
                console.log(result);
                this.agencies = result.data;
                this.paginator = result.paginator; 
            });
	}

	ngOnInit() {  
	    this.agencyService.getRepoAgencies(this.p).subscribe(result => {
                console.log(result);
                this.agencies = result.data;
                this.paginator = result.paginator; 
            }); 
	}
}


// WEBPACK FOOTER //
// ./src/app/repoagencies/agency.component.ts